import { Platform } from 'react-native'

const ASSISTANT_REGULAR = 'Assistant-Regular'
const ASSISTANT_BOLD = 'Assistant-Bold'
const OLD_STANDARD = 'OldStandardTT-Regular'

const colors: Colors = {
  primary: '#3E2A96',
  primaryDark: '#2E176C',
  secondary: '#E84250',
  accent: '#D2A753',
  primaryLight: '#DDE1F6',
  background: '#ffffff',
  backgroundSecondary: '#F8F8F8',
  backgroundTertiary: '#e5e5e5',
  disable: '#BEBEBE',
  disableDark: '#AFAFAF',
  primaryText: '#1F1F1F',
  secondaryText: '#787D87',
  segmentedActive: '#FAFAFF',
  primaryFocused: '#C6BDE2',
  secondaryActive: '#ECE9F5',
  negate: '#D1402F',
  cardDisabled: '#ecedf1',
  modalBackground: 'rgba(0, 0, 0, 0.3)',
  alert: '#DC1B2B',
  alertSecondary: '#FDECEA',
  alertDark: '#611A15',
  cardSecondary: '#F5F6FA',
  cardIcon: '#D4D8E9',
  incident: '#F7F7F9',
  alertButton: '#C8880B',
  alertButtonLight: '#F5E3C0',
  linkDisabled: '#C4C0DD',
  tertiary: '#8A8A8E',
  border: '#DEDEDE',
  priority: '#FECCC7',
  // Incindent States
  abandoned: '#C6C6C8',
  abandonedLight: '#F4F4F4',
  closed: '#5EA083',
  closedLight: '#D5EEE6',
  quote: '#756DF3',
  quoteLight: '#E5E0FF',
  waiting: '#F6BD44',
  waitingLight: '#FFF2CB',
  treating: '#90D3FB',
  treatingLight: '#E1F6FF',
}

const createTheme = (breakpoint: 'phone' | 'small' | 'medium' | 'mediumBig' | 'big', insets: Insets): Theme => ({
  colors: {
    ...colors,
  },
  fonts: {
    LoginTitle: {
      fontFamily: OLD_STANDARD,
      fontSize: '78px',
      lineHeight: '94px',
      letterSpacing: '0.4px',
      color: colors.primaryText,
    },
    Heading1: {
      fontFamily: ASSISTANT_BOLD,
      fontSize: '48px',
      lineHeight: '56px',
      color: colors.primaryText,
    },
    LargeTitle: {
      fontFamily: ASSISTANT_BOLD,
      fontSize: '34px',
      lineHeight: '41px',
      letterSpacing: '0.4px',
      color: colors.primaryText,
    },
    Title1: {
      fontFamily: ASSISTANT_BOLD,
      fontSize: '28px',
      lineHeight: '34px',
      letterSpacing: '0.35px',
      color: colors.primaryText,
    },
    Title2: {
      fontFamily: ASSISTANT_REGULAR,
      fontSize: '22px',
      lineHeight: '28px',
      letterSpacing: '0.35px',
      color: colors.primaryText,
    },
    Title3: {
      fontFamily: ASSISTANT_BOLD,
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0.4px',
      color: colors.primaryText,
    },
    Headline: {
      fontFamily: ASSISTANT_BOLD,
      fontSize: '17px',
      lineHeight: '22px',
      letterSpacing: '-0.4px',
      color: colors.primaryText,
    },
    Body: {
      fontFamily: ASSISTANT_REGULAR,
      fontSize: '17px',
      lineHeight: '22px',
      letterSpacing: '-0.4px',
      color: colors.primaryText,
    },
    Callout: {
      fontFamily: ASSISTANT_BOLD,
      fontSize: '16px',
      lineHeight: '21px',
      letterSpacing: '-0.3px',
      color: colors.primaryText,
    },
    Subheadline: {
      fontFamily: ASSISTANT_BOLD,
      fontSize: '15px',
      lineHeight: '20px',
      letterSpacing: '-0.25px',
      color: colors.primaryText,
    },
    Option: {
      fontFamily: ASSISTANT_REGULAR,
      fontSize: '14px',
      lineHeight: '18px',
      color: colors.primaryText,
    },
    Footnote: {
      fontFamily: ASSISTANT_REGULAR,
      fontSize: '13px',
      lineHeight: '18px',
      letterSpacing: '-0.1px',
      color: colors.primaryText,
    },
    Caption1: {
      fontFamily: ASSISTANT_REGULAR,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0px',
      color: colors.primaryText,
    },
    Caption2: {
      fontFamily: ASSISTANT_REGULAR,
      fontSize: '11px',
      lineHeight: '13px',
      letterSpacing: '0.05px',
      color: colors.primaryText,
    },
  },
  constants: {
    shadow:
      Platform.OS === 'web'
        ? 'box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1)'
        : {
            shadowColor: '#000000',
            shadowOffset: {
              width: 0,
              height: 0,
            },
            shadowOpacity: '0.23',
            shadowRadius: 5,
          },
  },
  breakpoint,
  insets,
})

const theme = createTheme('phone', { bottom: 0, top: 0 })

export { createTheme }
export default theme
